<template>
  <v-app :dark="dark">
    <vue-dialog />
    <router-view></router-view>
    <div id="v-console-container"></div>
  </v-app>
</template>

<script>
import Vue from "vue";

import Conf from "@/config.js";
const conf = Conf.use(Vue);

import Router from "@/router.js";
const router = Router.use(Vue);

import Store from "@/store.js";
const store = Store.use(Vue);

import { Ajax, UiFramework, Console } from "javaee-fre";

UiFramework.use(Vue, store, conf.vuetifyTheme, conf.vuetifyOptions);
Ajax.use(Vue, router, store, conf.baseUrl);
Console.use(Vue);

//----定义全局loading的函数---------
Vue.prototype.$loading = function (msg) {
  if (msg) {
    this.$store.commit("loading", {
      show: true,
      msg: msg === true ? "正在处理~请稍后！" : msg,
    });
  } else {
    this.$store.commit("loading", {
      show: false,
    });
  }
};

//isSuper
Vue.prototype.$isInRole = function (rn) {
  let a = this.$store.state.account;
  if (!a || !a.roles) {
    return false;
  }
  return a.roles.findIndex((r) => r.id == rn) >= 0;
};

Vue.prototype.$isSuperman = function () {
  return this.$isInRole("ROLE_SUPER");
};

//Notifications的显示函数
Vue.prototype.$notify = function (msg, func) {
  if (!msg) {
    return;
  }
  if (typeof msg === "string") {
    msg = { inner: true, msg: msg, read: true, ts: Date.now() };
  }
  msg.func = func;
  this.$store.commit("notify", msg);
};

//----处理刷新首次深层路由带来的问题,把第三层导航删掉------
let _first = true,
  _queue = [];
router.beforeResolve((to, from, next) => {
  if (_first && from.path == "/") {
    _first = false;
    let matched = to.matched;
    if (matched && matched.length > 2) {
      for (let i = 0; i < matched.length - 1; i++) {
        _queue.push(matched[i].path);
      }
    }
  }
  if (_queue.length > 0) {
    next(_queue.shift());
    return;
  }
  next();
});

import "javaee-fre/dist/javaee-fre.css";

export default {
  name: "app",
  router,
  store,
  computed: {
    dark() {
      return this.$store.state.dark;
    },
  },
  created() {
    this.$router.push("/ctxcheck");
  },
  beforeMount() {
    let self = this,
      { tid, oid, cc } = self.$query();
    if (tid) {
      self.$axios
        .get("/p/a/t", {
          params: {
            tid: tid,
            oid: oid,
            cc: cc,
          },
        })
        .then((resp) => {
          let data = resp.data;
          if (data.status == "ok" && data.message) {
            let tenant = data.message;
            if (tenant.logo) {
              tenant.logo = `${self.$const.baseUrl}/p/a/timg/${tid}/${tenant.logo.split("/")[0]
                }`;
            }
            try {
              let title = tenant.appName || tenant.name;
              if (title) {
                document.title = title;
              }
              if (tenant.favicon) {
                document.querySelector('link[rel="icon"]').href = `${self.$const.baseUrl
                  }/p/a/timg/${tid}/${tenant.favicon.split("/")[0]}`;
              }
            } catch (e) {
              //ignore.
            }
            self.$store.commit("tenant", tenant);
          }
        });
    }
  },
  mounted() {
    let self = this;
    if (self.$url.getParams()['open_v_console']) {
      self.initVConsole();
    }
  },
  methods: {
    initVConsole() {
      document.getElementById('v-console-container').innerHTML = '';
      let s = document.createElement('script');
      s.src = 'https://unpkg.com/vconsole/dist/vconsole.min.js';
      s.type = 'text/javascript';
      document.getElementById('v-console-container').appendChild(s);
      s.onload = function () {
        // eslint-disable-next-line no-unused-vars
        //let vConsole = new window.VConsole()
        new window.VConsole();
      }
    },
  }
};
</script>

<style>
/*全局清除掉部分浏览器的默认留白 */
html,
body,
#app {
  margin: 0;
  padding: 0;
}
</style>
